import request from '@/utils/request'
const shopCreate = (data)=>{
   return request({
     url:'/newMall/categories/create',
     method:'post',
     data
   })
}

const shopDelete = (data)=>{
  return request({
    url:'/newMall/categories/delete',
    method:'post',
    data
  })
}

// 获取分类下拉框列表
const getCategoriesSelectList = (data)=>{
  return request({
    url:'/newMall/categories/getCategoriesSelectList',
    method:'post',
    data
  })
}

const queryDetail = (data)=>{
  return request({
    url:'/newMall/categories/queryDetail',
    method:'post',
    data
  })
}

const queryList = (data)=>{
  return request({
    url:'/newMall/categories/queryList',
    method:'post',
    data
  })
}

const shopUpdate = (data)=>{
  return request({
    url:'/newMall/categories/update',
    method:'post',
    data
  })
}

const getChannelSelectList = (data)=>{
  return request({
    url:'/newMall/channel/getChannelSelectList',
    method:'post',
    data
  })
}

const couponImportDownload = (data)=> {
  return request({
    url: '/coupon/import/download',
    method: 'get',
    params: data,
    responseType: 'blob',
  })
}

export {
  shopUpdate,queryList,queryDetail,getCategoriesSelectList,shopDelete,shopCreate,getChannelSelectList,couponImportDownload
}


// WEBPACK FOOTER //
// ./src/api/shop/shopTypeManage.js